// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__fKpQE","detailsBorder":"styles_detailsBorder__2z3ZC"};